import { render, staticRenderFns } from "./OldVersionsContent.vue?vue&type=template&id=61e7e4d3"
import script from "./OldVersionsContent.vue?vue&type=script&lang=js"
export * from "./OldVersionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports